/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const Icons1 = ({ color = "white", className }) => {
  return (
    <svg
      className={`icons-1 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M18.0002 7.99999C18.0002 6.40869 17.368 4.88257 16.2428 3.75735C15.1176 2.63213 13.5915 1.99999 12.0002 1.99999C10.4089 1.99999 8.88275 2.63213 7.75753 3.75735C6.63231 4.88257 6.00017 6.40869 6.00017 7.99999C6.00017 15 3.00017 17 3.00017 17H21.0002C21.0002 17 18.0002 15 18.0002 7.99999Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.99832"
      />

      <path
        className="path"
        d="M13.7302 21C13.5544 21.3028 13.302 21.5542 12.9984 21.7289C12.6948 21.9036 12.3506 21.9956 12.0002 21.9956C11.6498 21.9956 11.3056 21.9036 11.002 21.7289C10.6983 21.5542 10.446 21.3028 10.2702 21"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.99832"
      />
    </svg>
  );
};

Icons1.propTypes = {
  color: PropTypes.string,
};
